// Handle address form submit button click
const addressFormSubmitButton = document.querySelector(
  "#address-form-submit-button",
);
if (addressFormSubmitButton) {
  addressFormSubmitButton.addEventListener("click", function () {
    const stepOne = document.querySelector("#step-one");
    const stepTwo = document.querySelector("#step-two");
    if (stepOne) stepOne.hidden = true;
    if (stepTwo) stepTwo.hidden = false;
    const firstNameField = document.querySelector("#FirstName");
    if (firstNameField) firstNameField.focus();
    window.scrollTo({ top: 0 });
  });
}

// Listen to unit-number field (which maps to address2)
const unitNumberFieldReg = document.querySelector("#unit-number");
if (unitNumberFieldReg) {
  unitNumberFieldReg.addEventListener("keyup", function (e) {
    var addTwo = e.target.value;
    addressInfo.address2 = addTwo;
    // Also update hidden address2 field for compatibility
    const address2FieldHidden = document.querySelector("#address2");
    if (address2FieldHidden) {
      address2FieldHidden.value = addTwo;
    }
  });
}

// Fallback: also listen to address2 if it exists and is not hidden (for backward compatibility)
const address2FieldVisible = document.querySelector("#address2");
if (address2FieldVisible && address2FieldVisible.type !== "hidden") {
  address2FieldVisible.addEventListener("keyup", function (e) {
    var addTwo = e.target.value;
    addressInfo.address2 = addTwo;
  });
}

var UNASSIGNED_US_AREA_CODES = new Set([
  "200",
  "211",
  "222",
  "266",
  "277",
  "282",
  "288",
  "299",
  "300",
  "311",
  "322",
  "333",
  "411",
  "511",
  "555",
  "611",
  "711",
  "811",
  "911",
]);

function isValidUSPhone10(digits) {
  if (typeof digits !== "string" || digits.length !== 10) return false;
  if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return false;
  var areaCode = digits.slice(0, 3);
  if (UNASSIGNED_US_AREA_CODES.has(areaCode)) return false;
  return true;
}
window.isValidUSPhone10 = isValidUSPhone10;

document.querySelector("#phone_number").addEventListener("input", function (e) {
  var digits = e.target.value.replace(/\D/g, "").slice(0, 10);
  e.target.value = digits;
  addressInfo.phone = digits;

  var phoneValidationMessage = document.getElementById(
    "phone-validation-message",
  );
  if (
    digits.length === 0 ||
    (digits.length === 10 && isValidUSPhone10(digits))
  ) {
    e.target.classList.remove("input--error");
    if (phoneValidationMessage) phoneValidationMessage.style.display = "none";
  }
});

document.querySelector("#phone_number").addEventListener("blur", function (e) {
  var digits = e.target.value.replace(/\D/g, "");
  var phoneValidationMessage = document.getElementById(
    "phone-validation-message",
  );
  var invalidLength = digits.length > 0 && digits.length < 10;
  var invalidFormat = digits.length === 10 && !isValidUSPhone10(digits);
  if (invalidLength || invalidFormat) {
    e.target.classList.add("input--error");
    if (phoneValidationMessage) phoneValidationMessage.style.display = "block";
  }
});

function updateValidateRegistrationField() {
  const validateField = document.querySelector("#validate_registration");
  if (validateField && typeof addressInfo !== "undefined") {
    validateField.value = JSON.stringify({ addressInfo });
  }
}

document
  .querySelector("#CreatePassword")
  .addEventListener("keyup", function () {
    updateValidateRegistrationField();
  });

const createCustomerForm = document.getElementById("create_customer");
if (createCustomerForm) {
  createCustomerForm.addEventListener("submit", function () {
    updateValidateRegistrationField();
  });
}

const passwordField = document.querySelector("#CreatePassword");
if (passwordField) {
  ["change", "input"].forEach((eventName) => {
    passwordField.addEventListener(eventName, function () {
      updateValidateRegistrationField();
    });
  });
}

document.querySelectorAll("input").forEach((input) => {
  input.addEventListener("input", function (e) {
    const passwordTest = /(?=.*\d)(?=.*[A-Za-z]).{8,}/.test(
      document.querySelector("#CreatePassword").value,
    );

    if (passwordTest) {
      document.querySelector(".form_validate").style.display = "none";
    }

    if (
      document.querySelector("#FirstName").value &&
      document.querySelector("#LastName").value &&
      document.querySelector("#CreatePassword").value &&
      passwordTest
    ) {
      document.querySelector(".create_account").disabled = false;
    }
  });
});

document
  .querySelector("#CreatePassword")
  .addEventListener("focusout", function (e) {
    if (!/(?=.*\d)(?=.*[A-Za-z]).{8,}/.test(e.target.value)) {
      document.querySelector(".form_validate").style.display = "block";
      document.querySelector(".create_account").disabled = true;
    } else {
      document.querySelector(".form_validate").style.display = "none";
    }
  });

document
  .querySelector(".create_account_btn")
  .addEventListener("mouseup", function (e) {
    e.stopPropagation();
    e.preventDefault();

    if (
      !/(?=.*\d)(?=.*[A-Za-z]).{8,}/.test(
        document.querySelector("#CreatePassword").value,
      )
    ) {
      document.querySelector(".form_validate").style.display = "block";
    } else {
      document.querySelector(".form_validate").style.display = "none";
    }
  });

document
  .querySelector(".create_account")
  .addEventListener("touchend", function (e) {
    if (
      !/(?=.*\d)(?=.*[A-Za-z]).{8,}/.test(
        document.querySelector("#CreatePassword").value,
      )
    ) {
      document.querySelector(".form_validate").style.display = "block";
    } else {
      document.querySelector(".form_validate").style.display = "none";
    }
  });
